import { ObjectDetailMapper } from '@frontend/components/detail';
import { ICONS } from '@frontend/icons';
import { useActiveModal, useModals } from '@frontend/modal';

export interface IotDataModalProps {
    data: { [key: string]: unknown };
}
const IotDataModal = (props: IotDataModalProps) => {
    const { modalId } = useActiveModal();
    const { closeModal } = useModals();
    return (
        <div className='bg-background-surface'>
            <div className='modal-header flex justify-between'>
                <h4>Data</h4>
                <button
                    id='close-button'
                    type='button'
                    className='btn btn-brand-secondary m-0'
                    onClick={() => closeModal(modalId!)}>
                    <ICONS.BUTTON.CLOSE_2 />
                </button>
            </div>
            <div className='modal-body'>
                <ObjectDetailMapper
                    object={props.data}
                    hidden={['id', 'delete_timestamp']}
                    queryParamNavigation
                />
            </div>
        </div>
    );
};

export default IotDataModal;
